import styled, { css, keyframes } from "styled-components";
import { PlainTextStyle } from "../../styled";

export const SectionWhy = styled.section`
    padding-bottom: 150px;
`;

export const WhyContainer = styled.div`
    max-width: 1230px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 25px;
    padding-right: 25px;
    position: relative;
`;

export const WhyTitle = styled.div`
    font-weight: 700;
    font-size: 79px;
    margin-bottom: 74px;
    line-height: 1;
    position: relative;
    z-index: 1;
    @media (max-width: 1199px) {
        font-size: 60px;
        margin-bottom: 64px;
    }
    @media (max-width: 599px) {
        font-size: 50px;
        margin-bottom: 34px;
    }
`;

export const WhyWrapper = styled.div`
    position: relative;
`;

export const WhyCards = styled.div`
    position: relative;
    z-index: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    gap: 30px;
    counter-reset: num;
    @media (max-width: 767px) {
        gap: 20px;
        justify-content: center;
    }
`;

export const WhyCard = styled.div`
    position: relative;
    width: 47%;
    padding-left: 80px;
    &:before {
        position: absolute;
        counter-increment: num;
        content: counter(num) "";
        width: 74px;
        height: 74px;
        border-radius: 50%;
        background: rgb(227, 129, 70);
        font-size: 32px;
        font-weight: 700;
        color: rgb(249, 241, 221);
        top: 0%;
        left: -10px;
        display: flex;
        justify-content: center;
        align-items: center;
        @media (max-width: 599px) {
            left: -30px;
        }
        @media (max-width: 424px) {
            left: -30px;
            width: 40px;
            height: 40px;
            font-size: 28px;
        }
    }
    @media (max-width: 767px) {
        width: 70%;
    }
    @media (max-width: 599px) {
        padding-left: 50px;
    }
    @media (max-width: 424px) {
        padding-left: 20px;
        width: 90%;
    }
`;

export const WhyCardTitle = styled.h3`
    margin-bottom: 20px;
    position: relative;
    z-index: 1;
    font-size: 40px;
    font-weight: 700;
    line-height: 1;
    @media (max-width: 424px) {
        margin-bottom: 10px;
    }
`;

export const WhyCardText = styled.div`
    ${PlainTextStyle}
    line-height: 1.4;
`;

const circle = keyframes`
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(1.2);
  }
`;

const whyCircle = css`
    position: absolute;
    width: 600px;
    height: 600px;
    border-radius: 50%;
    border: 110px solid rgb(238, 210, 177);
    animation-name: ${circle};
    animation-duration: 6s;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
    animation-direction: alternate;
    @media (max-width: 599px) {
        width: 400px;
        height: 400px;
        border-radius: 50%;
        border: 70px solid rgb(238, 210, 177);
    }
`;

export const WhyCircleTop = styled.div`
    ${whyCircle}
    top: -3%;
    left: -25%;
`;

export const WhyCircleBottom = styled.div`
    ${whyCircle}
    bottom: -30%;
    right: -30%;
    @media (max-width: 599px) {
        bottom: 0%;
    }
`;
